import fwUtil from 'framework-util'

export function getDataService(url,data) {
  return custemRequest({
    url: url,
    method: 'get',
    params:data
  })
}

export function postDataService(url,data) {
  return custemRequest({
    url: url,
    method: 'post',
    data:data
  })
}




// WEBPACK FOOTER //
// ./src/api/chart/chart/index.js